import ObaBaseDAO from "./ObaBaseDAO";
import ObaUsuarioCadastroModel from "../../model/ObaUsuarioCadastroModel";
import LogUtil from "../../util/LogUtil";

class ObaUsuarioDAO extends ObaBaseDAO {
  private static instance: ObaUsuarioDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ObaUsuarioDAO {
    if (!ObaUsuarioDAO.instance) {
      ObaUsuarioDAO.instance = new ObaUsuarioDAO();
    }
    return ObaUsuarioDAO.instance;
  }

  public async getUsuario(email: string): Promise<ObaUsuarioCadastroModel> {
    return this.post(
      `REQ_OBA_CADUSER_${email}`,
      `${this.endpoint}/pessoa/consulta`,
      { email }
    ).then((r: any) => ObaUsuarioCadastroModel.toModel(r.data));
  }

  public async cadastraUsuario(
    cadastro: ObaUsuarioCadastroModel
  ): Promise<ObaUsuarioCadastroModel> {
    LogUtil.logEvento("ObaUsuarioDAO:cadastraUsuario", cadastro);
    return this.post(
      `REQ_OBA_CADUSER_INS_${cadastro.Email}`,
      `${this.endpoint}/pessoa/cadastro`,
      ObaUsuarioCadastroModel.toObaAPI(cadastro)
    ).then((r: any) => {
      return ObaUsuarioCadastroModel.toModel(r.data);
    });
  }
}

export default ObaUsuarioDAO;
